import { subscription } from "@/lib/pricing";

const MODS = { si: ["si"], rcc: ["rcc"], bundle: ["si", "rcc"] };
const DAY = 86400000;
const r2 = (n) => Math.round(n * 100) / 100;

// §82 Upgrade = starts now, pro-rata. Anything that removes a module, seats or annual = at renewal.
export const planChange = {
  current: (p) => ({ product: p?.product || "rcc", seats: p?.seats || p?.included?.users || 1, cycle: p?.cycle || "monthly" }),
  estimate: (cat, cur, next, renewsAt) => {
    const dropped = MODS[cur.product].some((x) => !MODS[next.product].includes(x));
    const down = dropped || next.seats < cur.seats || (cur.cycle === "annual" && next.cycle === "monthly");
    if (down) return { timing: "renewal", dueNow: 0 };
    const a = subscription(cat, cur.product, cur.seats, cur.cycle); const b = subscription(cat, next.product, next.seats, next.cycle);
    const period = cur.cycle === "annual" ? 365 : 30;
    const left = renewsAt ? Math.min(period, Math.max(0, (new Date(renewsAt) - Date.now()) / DAY)) : period;
    const f = left / period;
    const due = next.cycle === cur.cycle ? ((next.cycle === "annual" ? b.annual - a.annual : b.monthly - a.monthly) * f) : b.annual - a.monthly * f;
    return { timing: "now", dueNow: r2(Math.max(0, due)) };
  },
};
